<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('variable sets')"
      :columns="columns"
      :column_search="true"
      resource_url="/ngine/variable-set/datatables"
      mode="grid"
    >
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto" @click="">
              <img src="https://cdn-icons-png.freepik.com/512/762/762722.png" />
            </figure>
          </div>
          <div class="card-content px-0" @click="">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ item.name }}
                </p>
                <!-- <pre>{{ item }}</pre> -->
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
          </footer>
        </div>
      </template>
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <variable-set-modal ref="variable_set_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import VariableSetModal from "../variable_set_modal/Index.vue";

export default {
  name: "NgineVariableSetDatatable",
  components: { GenericTable, VariableSetModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          width: "15%",
          data: (row) => {
            return format_date(row.date);
            //return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.variable_set_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(process) {
      this.$refs.variable_set_modal.edit_modal(process.uuid);
    },
    remove(process) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to variable set?"), v, () => {
        del("/ngine/variable-set", { uuid: process.uuid })
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
